module.exports = __webpack_public_path__ + "img/long4.d897d07a.png";